import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaGavel, FaIdCard, FaGlobe, FaArrowRight } from 'react-icons/fa';

const JoinOrganization = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-gray-100 p-8 sm:p-10 transition-all hover:shadow-2xl text-center">
        
        {/* Header Icon */}
        <div className="mx-auto w-16 h-16 bg-red-100 text-red-600 rounded-2xl flex items-center justify-center mb-6 shadow-sm">
          <FaGavel className="w-8 h-8" />
        </div>

        {/* Title */}
        <h2 className="text-3xl font-black text-gray-900 tracking-tight mb-3">
          Join Organization
        </h2>
        
        <p className="text-gray-500 text-sm mb-8">
          Become a verified member of the IINSAF advocate federation.
        </p>

        {/* Short Details / Benefits */}
        <div className="space-y-5 text-left mb-8">
          <div className="flex items-start gap-3.5">
            <div className="mt-1 p-1.5 bg-red-50 text-red-600 rounded-lg">
              <FaIdCard className="w-4 h-4" />
            </div>
            <div>
              <h4 className="font-bold text-gray-900 text-sm leading-tight mb-0.5">Verified Digital ID</h4>
              <p className="text-xs text-gray-500 leading-relaxed">Receive a professional verified advocate ID card and profile page.</p>
            </div>
          </div>

          <div className="flex items-start gap-3.5">
            <div className="mt-1 p-1.5 bg-red-50 text-red-600 rounded-lg">
              <FaGlobe className="w-4 h-4" />
            </div>
            <div>
              <h4 className="font-bold text-gray-900 text-sm leading-tight mb-0.5">National Legal Network</h4>
              <p className="text-xs text-gray-500 leading-relaxed">Collaborate with advocates and legal professionals across India.</p>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <button
          onClick={() => navigate('/advocate/register')}
          className="w-full py-4 bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700 text-white font-bold rounded-2xl text-sm shadow-lg shadow-red-900/10 hover:shadow-red-900/20 transition-all flex items-center justify-center gap-2 group hover:scale-[1.02] active:scale-95"
        >
          Advocate Join Us <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
        </button>

      </div>
    </div>
  );
};

export default JoinOrganization;
